import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './DepositCategoryList.module.scss';
import DepositCategoryRow from './DepositCategoryRow';
import { MarketplaceDepositCategory } from '@spike/marketplace-model';
import { DEFAULT_DEPOSIT_CATEGORY_VALUE, DepositCategoryId, DepositCategoryValues } from './types';
import { ValueTypeSelectorValue } from 'components/UI/V3/Forms/ValueTypeSelector';

export interface DepositCategoryListProps {
    categories: Array<MarketplaceDepositCategory>;
    selected: Array<DepositCategoryId>;
    values: DepositCategoryValues;
    className?: string;
    onCheckedChange: (id: DepositCategoryId, checked: boolean) => void;
    onValueChange: (id: DepositCategoryId, value: ValueTypeSelectorValue) => void;
}

export const DepositCategoryList: FunctionComponent<DepositCategoryListProps> = ({
    categories,
    selected,
    values,
    className,
    onCheckedChange,
    onValueChange
}) => (
    <div className={clsx(styles.container, className)}>
        <p className={styles.label}>
            Select Services<span className={styles.required}>*</span>
        </p>
        <p className={styles.description}>Set a fixed amount or percentage that the customer must pay when booking.</p>

        {categories.length === 0 ? (
            <p className={styles.emptyState}>
                No service categories are enabled for your business. Enable one in Business Settings &gt; Business Info
                &gt; Service Categories to require a deposit on it.
            </p>
        ) : (
            <div className={styles.list}>
                {categories.map(category => (
                    <DepositCategoryRow
                        key={category.id}
                        id={category.id}
                        label={category.name}
                        checked={selected.includes(category.id)}
                        value={values[category.id] ?? DEFAULT_DEPOSIT_CATEGORY_VALUE}
                        onCheckedChange={onCheckedChange}
                        onValueChange={onValueChange}
                    />
                ))}
            </div>
        )}
    </div>
);

export default DepositCategoryList;
